module.exports = __webpack_public_path__ + "static/ettin-c02db131d11352627dca41378e429b9e.jpg";